import { urlCreateEstimate } from "./urls"

export const messagesAddEstimate = { 
    type : 'addEstimate',
    url : urlCreateEstimate,
    messageTextsOK : {
        messageTitle : 'Presupuesto guardado con éxito',
        buttonLeft : '',
        buttonRight: 'Continuar'
    },
    messageTextsKO : {
        messageTitle : 'Ha habido un error, intentelo de nuevo',
        messageUniqueKey : 'La dirección de la obra debe ser única para cada presupuesto',
        buttonLeft : '',
        buttonRight: 'Volver a presupuestos'
    }
}
export const messagesEditEstimate = { 
    type : 'editEstimate',
    url : urlCreateEstimate,
    messageTextsOK : {
        messageTitle : 'Presupuesto modificado con éxito',
        buttonLeft : 'Volver a presupuestos',
        buttonRight: 'Imprimir'
    },
    messageTextsKO : {
        messageTitle : 'Ha habido un error, intentelo de nuevo',
        messageUniqueKey : 'La dirección de la obra debe ser única para cada presupuesto',
        buttonLeft : '',
        buttonRight: 'Volver a presupuestos'
    }
}